var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.hiddenField.value,
          expression: "hiddenField.value"
        }
      ],
      attrs: {
        type: "hidden",
        id: _vm.hiddenField.id,
        name: _vm.hiddenField.name,
        required: _vm.hiddenField.required
      },
      domProps: { value: _vm.hiddenField.value },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.$set(_vm.hiddenField, "value", $event.target.value)
        }
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "bar" }, [
      _c("div", { staticClass: "md-form" }, [
        _c("i", {
          staticClass: "fa prefix text-skin--primary",
          class: _vm.hiddenField.value
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchString,
              expression: "searchString"
            }
          ],
          staticClass: "form-control",
          attrs: { type: "text", id: "select-icon--search" },
          domProps: { value: _vm.searchString },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.searchString = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c("label", { attrs: { for: "select-icon--search" } }, [
          _vm._v("Search...")
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { id: "select-icon-type--scrollable-container" } },
      _vm._l(_vm.filteredIcons, function(icon) {
        return _c(
          "button",
          {
            staticClass: "select-icon-type btn btn-md waves-effect waves-light",
            class: {
              "btn-primary": icon.active,
              "btn-secondary": !icon.active
            },
            attrs: { type: "button" },
            on: {
              click: function($event) {
                _vm.makeActive(icon)
              }
            }
          },
          [_c("i", { class: _vm.createIconClass(icon) })]
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c13ae7b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c13ae7b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/forms/IconChooser.vue
// module id = 304
// module chunks = 0